import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../state/store";
import { getLoginLogListAction } from "../../../../state/usecase/admin/login_log/actions";
import { LoginLogFilter } from "./LoginLogFilter";
import { LoginLogGraph } from "./LoginLogGraph";
import { LoginLogMonthlyTotal } from "./LoginLogMonthlyTotal";
import { LoginLogTable } from "./LoginLogTable";

export function LoginLogList() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getLoginLogListAction());
    }, [dispatch]);

    return (
        <div className={"admin_login_log_list_page"}>
            {/* ページタイトル */}
            <div className={"header"}>
                ログイン履歴一覧
            </div>

            {/* ページコンテンツ */}
            <div className={"container"}>
                {/* フィルター */}
                <LoginLogFilter />
                {/* 月ごとのログイン数合計 */}
                <LoginLogMonthlyTotal />
                {/* 日ごとのログイン数グラフ */}
                <LoginLogGraph />
                {/* 全ログインデータの表 */}
                <LoginLogTable />
            </div>
        </div>
    );
}
